import { render, staticRenderFns } from "./_tasksLast30DaysChart.vue?vue&type=template&id=1bfee84c"
import script from "./_tasksLast30DaysChart.vue?vue&type=script&lang=js"
export * from "./_tasksLast30DaysChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports